module.exports = __webpack_public_path__ + "img/logo.1d909652.png";